/**
 * API Configuration and Endpoints
 * Central location for all API endpoints and configuration
 */

// Base API Configuration
export const API_CONFIG = {
  BASE_URL: process.env.REACT_APP_API_ENDPOINT,
  ANSWERS_BASE_URL: process.env.REACT_APP_API_ENDPOINT_ANSWERS,
  TIMEOUT: parseInt(process.env.REACT_APP_API_TIMEOUT || '30000', 10),
  MAX_RETRIES: 3, // Number of retries for failed requests
  RETRY_DELAY: 1000, // Initial delay between retries in ms
  ENVIRONMENT: process.env.REACT_APP_ENVIRONMENT || 'development',
  DEBUG: process.env.REACT_APP_ENABLE_DEBUG === 'true',
  LOGGING: process.env.REACT_APP_ENABLE_LOGGING === 'true',
  REPROCESS: process.env.REACT_APP_REPROCESS_EMAILS || '',
} as const;

// API Endpoints
export const API_ENDPOINTS = {
  // Authentication endpoints
  AUTH: {
    LOGIN: '/app/v1/eb/login',
    REQUEST_RESET: '/app/v1/eb/forgot-password',
    COMPLETE_RESET: '/app/v1/eb/reset-password',
  },

  // Email endpoints
  EMAILS: {
    LIST: '/app/v1/eb/emailsList',
    DETAILS: (emailId: string | number) => `/app/v1/eb/emailDetailsById/${emailId}`,
    ACTIONS: (emailId: string | number) => `/app/v1/eb/updateEmailStatus/${emailId}`,
    CONFIG_DETAILS: "/app/v1/eb/emailProcessingConfig",
    UPDATE_CONFIG: (id: number | string) => `/app/v1/eb/updateConfigDetails/${id}`,
    EDIT_QUESTIONS: (id: number | string) => `/app/v1/eb/answerData/${id}`,
    QUESTIONS: "/app/v1/eb/questions",
    REPROCESS: "api/ReprocessEmails",
    REUPLOAD:"api/upload-pricing-calculator"
  },

  // Answers endpoints (uses separate base URL)
  ANSWERS: {
    WEB_EDITED_ANSWERS: '/api/web-edited-answers',
  },
} as const;

// HTTP Methods
export const HTTP_METHODS = {
  GET: 'GET',
  POST: 'POST',
  PUT: 'PUT',
  DELETE: 'DELETE',
  PATCH: 'PATCH',
} as const;

// Common HTTP Headers
export const HTTP_HEADERS = {
  JSON: {
    'Content-Type': 'application/json',
  },
  CORS: {
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Methods': 'GET, POST, PUT, DELETE, OPTIONS',
    'Access-Control-Allow-Headers': 'Origin, Content-Type, Accept, Authorization, X-Requested-With',
  },
} as const;
